import { Skeleton } from "antd";
import { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { templateAction } from "../../actions/template-action";
import UrlTemplate from "./one-template/url-template";
import NotFoundPage from "./page-not-found/page-not-found";
import TemplateTwo from "./second-template/template-two";

const PIXEL_CLIENT_ID = 13;
const PIXEL_SCRIPT_ID = "jovscript";
const PIXEL_SCRIPT_SRC =
  "//jotrack.s3.us-east-1.amazonaws.com/q8rh/universal-pixel.js";
const DRIVE4JRS_HOSTS = [
  "drive4jrs.com",
  "www.drive4jrs.com",
  "hire.drive4jrs.com",
];
const DRIVEJRSCHUGEL_HOST = "hire.drivejrschugel.com";

const getTemplateLookupUrl = () => {
  const currentUrl = new URL(window.location.href);

  if (DRIVE4JRS_HOSTS.includes(currentUrl.hostname.toLowerCase())) {
    window.location.href = window.location.href.replace(
      currentUrl.hostname,
      DRIVEJRSCHUGEL_HOST,
    );
    return null;
  }

  return currentUrl.href;
};

const LandingPageDecider = () => {
  const dispatch = useDispatch();
  const [data, setData] = useState();
  const [templateType, setTemplateType] = useState();
  const [loading, setLoading] = useState(true);
  const [isTemplateNotFound, setIsTemplateNotFound] = useState(false);

  // let templateURL = window.location.pathname.substring(1);
  const templateURL = getTemplateLookupUrl();

  const injectPixelScript = () => {
    if (document.getElementById(PIXEL_SCRIPT_ID)) return;

    const pixelScript = document.createElement("script");
    pixelScript.type = "text/javascript";
    pixelScript.id = PIXEL_SCRIPT_ID;
    pixelScript.src = PIXEL_SCRIPT_SRC;
    document.head.appendChild(pixelScript);
  };

  const fetchSuccess = (res) => {
    const clientId = Number(
      res && res.data && res.data.client && res.data.client.id,
    );
    if (clientId === PIXEL_CLIENT_ID) {
      injectPixelScript();
    }

    setTemplateType(res?.data?.templateType);
    setLoading(false);
  };

  const fetchFail = (res) => {
    setLoading(false);
    setIsTemplateNotFound(true);
  };

  const templateDecider = (value) => {
    switch (value) {
      case 1:
        return {
          template: <UrlTemplate />,
        };
      case 2:
        return {
          template: <TemplateTwo />,
        };
    }
  };

  useEffect(() => {
    if (templateURL) {
      dispatch(
        templateAction.getTemplateDetails(templateURL, fetchSuccess, fetchFail),
      );
    }
  }, []);

  useEffect(() => {
    const templateData = templateDecider(templateType);
    setData(templateData);
  }, [templateType]);

  return (
    <Skeleton active loading={loading}>
      {isTemplateNotFound ? <NotFoundPage /> : data?.template}
    </Skeleton>
  );
};

export default LandingPageDecider;
